import { render, staticRenderFns } from "./PalettePicker.vue?vue&type=template&id=2706e4d4&scoped=true"
import script from "./PalettePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./PalettePicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PalettePicker.vue?vue&type=style&index=0&id=2706e4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706e4d4",
  null
  
)

export default component.exports